import * as React from 'react';
import {Button, ButtonGroup, Col} from 'reactstrap';
import renderDatePickerField from '../../../theme/components/form/DatePicker';
import {Field, InjectedFormProps, reduxForm} from 'redux-form';
import CalendarBlankIcon from 'mdi-react/CalendarBlankIcon';
import validate from './validate';
import * as moment from 'moment';
import Panel from '../../../theme/components/Panel';
import renderSelectField from '../../../theme/components/form/Select';

class ComprobantesForm extends React.PureComponent<InjectedFormProps> {

    public render() {
        const {handleSubmit, resumenDiario} = this.props;
        return (
            <Panel xs={12} md={12} divider={true} title='Filtros'>
                <form className='form' onSubmit={handleSubmit}>
                    <Col md={12}>
                        <div className='form__form-group'>
                            <label className='form__form-group-label'>Fecha</label>
                            <div className='form__form-group-field'>
                                <Field
                                    name='fecha'
                                    component={renderDatePickerField}
                                    filterDate={(date) => {
                                        return moment() > date;
                                    }}
                                    defaultDate={moment()}
                                    placeholder='dd/mm/yyyy'
                                />
                                <div className='form__form-group-icon'>
                                    <CalendarBlankIcon/>
                                </div>
                            </div>
                        </div>
                        <div className='form__form-group'>
                            <label className='form__form-group-label'>Ruta</label>
                            <div className='form__form-group-field'>
                                <Field
                                    name='ruta'
                                    component={renderSelectField}
                                    placeholder='Seleccione'
                                    type='text'
                                    options={resumenDiario.map((res) => {
                                        return {value: res.ruta.id, label: res.ruta.descripcion}
                                    })}
                                />
                            </div>
                        </div>
                        <ButtonGroup className='btn-group--justified'>
                            <Button color='success' type='submit'>FILTRAR</Button>
                        </ButtonGroup>
                    </Col>
                </form>
            </Panel>
        )
    }
}

export default reduxForm({
    form: 'comprobantes_form', // a unique identifier for this form
    validate,
})(ComprobantesForm);


// WEBPACK FOOTER //
// ./src/components/pages/comprobantes/comprobantes-form.tsx